enum QuizEventTypes {
  Manual = 'manual',
};

export default QuizEventTypes;
